<div class="server-content">
  <form novalidate #currentForm="ngForm">
    <div class="server-header">
      <div class="title">Server address</div>
    </div>
    <div class="server-selection">
      <div class="server-title title">Address *</div>
      <div class="server-ip">
        <input autocomplete="off" class="serverIp" placeholder="IP address" class="alias"
               [(ngModel)]="serverIp" (ngModelChange)="enterServerIp()" name="address" #addressInput="ngModel" required
               maxlength="50" matInput [pattern]="validAddressRegex" />
      </div>
    </div>
    <div class="error" *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)">
      <mat-error *ngIf="addressInput.errors.pattern">Address is invalid.</mat-error>
    </div>
  </form>
</div>
